import React, { Component } from "react";

export default class AvisoGeneral extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }


  render(props) {
    if(this.props.prestamos?.length > 0 || this.props.prestamos === undefined){
      return (
        <div className="col-md-12 mt-2">
            
            <div className="row">
              <div className="col-md-12">
                <div className="callout callout-success" style={{border:"1px solid #006a2d",backgroundColor:"#ffffff00",boxShadow: "none"}}>
                  <div className="row">
                    <div className="col-md-12">
                      <i className="fas fa-exclamation-circle card-fa-icono-info" style={{marginRight: 5,fontSize:25}}/> 
                      <p style={{fontSize:20}}>Importante!</p> 
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12" style={{color:"red"}}>
                    *Debe actualizar los archivos señalados.
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      );

    }else{
      return null;
    }  
  }
}